import { SearchField, Stack } from '@eleveo/components-react';
import { FormApi } from 'final-form';
import React from 'react';
import { Form, FormRenderProps, useFormState } from 'react-final-form';
import { useTranslation } from 'react-i18next';

import { useDebouncedField } from '../../utils/useDebounceField';
import { max255chars } from '../../utils/validations';
import { SEARCH_REQUESTS_CONTAINER_TAG } from './constants';

interface RequestsHeaderFilter {
  agentName: string;
  agentSurname: string;
}

export type RequestsHeaderFilterType = Partial<RequestsHeaderFilter>;

interface RequestsHeaderSearchFormProps {
  onSubmit: (values: RequestsHeaderFilterType, formProps: FormApi<RequestsHeaderFilterType>) => void;
}

const RequestsHeaderSearchFormInner = ({ handleSubmit }: FormRenderProps) => {
  const { t } = useTranslation();

  useFormState<RequestsHeaderFilterType>({
    subscription: { dirty: true, modified: true, values: true },
    onChange: ({ modified }) => {
      // Do not fire on initial render, when updating state is causing React error
      if (modified?.agentName || modified?.agentSurname) {
        handleSubmit();
      }
    },
  });

  const { input: nameInput } = useDebouncedField('agentName', { validate: max255chars });
  const { input: surnameInput } = useDebouncedField('agentSurname', { validate: max255chars });

  return (
    <form>
      <Stack direction="horizontal" testId={SEARCH_REQUESTS_CONTAINER_TAG}>
        {/* TODO: At final state, single <SearchField /> component should be used to provide full-search behavior upon any field within table */}
        <SearchField
          placeholder={t('person.firstName')}
          testId="list-filter:input-search--name"
          {...nameInput}
          className="agents-header-search-form__search"
        />

        <SearchField
          placeholder={t('person.lastName')}
          testId="list-filter:input-search--surname"
          {...surnameInput}
          className="agents-header-search-form__search"
        />
      </Stack>
    </form>
  );
};

export const RequestsHeaderSearchForm: React.FC<RequestsHeaderSearchFormProps> = ({ onSubmit }) => (
  <Form<RequestsHeaderFilterType>
    onSubmit={onSubmit}
    data-test-id="requests-header-search-form"
    component={RequestsHeaderSearchFormInner}
  />
);
